import * as React from 'react';
import classNames from 'classnames';
import * as Classes from '../common/classes';

type Props = {
  className?: string;
  horizontal?: boolean;
  children?: React.ReactNode;
};

export const RadioGroup: React.FC<Props> = ({
  className,
  horizontal,
  children,
  ...other
}) => {
  let cls = classNames(className, Classes.RADIO_GROUP, {
    [Classes.RADIO_GROUP_HORIZONTAL]: horizontal,
  });

  return (
    <div className={cls} onChange={() => {}} {...other}>
      {children}
    </div>
  );
};
